import React, { ReactElement } from 'react';

function Recursor(
  entities: Record<string, unknown>,
  window: Window & typeof globalThis
): ReactElement[] {
  if (!entities || !window) return [];

  // Apply default renderer recursively
  const defaultRenderer = (entity, key) => {
    if (typeof entity.renderer === 'object')
      return <entity.renderer.type key={key} window={window} entity={entity} />;
    else if (typeof entity.renderer === 'function')
      return <entity.renderer key={key} window={window} entity={entity} />;

    return undefined;
  };
  const recursiveRenderer = (list, key = '0') => {
    const acc: ReactElement[] = [];

    if (list.length === 0) return [];
    list.forEach((element, idx) => {
      if (element && element.renderer) {
        const render = defaultRenderer(element, `entities_${key}_${idx}`);

        if (render) acc.push(render);
      } else if (Array.isArray(element))
        acc.push(...recursiveRenderer(element, `${key}_${idx}`));
    });

    return acc;
  };

  return recursiveRenderer(Object.values(entities));
}

export default Recursor;
